import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { PromoContentService } from 'src/app/core/services/promo-content-service/promo-content.service';
import { environment } from 'src/environments/environment';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SanitizeHtmlPipe } from 'src/app/core/pipes/sanitize-html.pipe';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { Router } from '@angular/router';
import { IdleService } from 'src/app/core/services/idle-service/idle.service';

@Component({
  selector: 'app-promo-content-tiles',
  templateUrl: './promo-content-tiles.component.html',
  styleUrls: ['./promo-content-tiles.component.scss']
})
export class PromoContentTilesComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedPromoIndex!: number;
  promoContentData: any;
  selectedPromoID !: number;
  assetsUrl !: string;
  playVideo: boolean = false;
  setIntelDisplayOneFont: boolean = false;
  compareButtonText: string = '';
  isPantherLakeStd: boolean = false;
  isPantherLakeGaming: boolean = false;
   iswildCatLakeStd: boolean = false;

  @ViewChild('playPauseIcon') playPauseIcon!: ElementRef;
  @ViewChildren('videoPlayerContainer') videos!: QueryList<ElementRef<HTMLVideoElement>>;
  private ngUnsubscribe = new Subject<boolean>();
  private observer!: IntersectionObserver;
  private playingState = new WeakMap<HTMLVideoElement, boolean>();
  private userInteracted = new WeakMap<HTMLVideoElement, boolean>();
  private endedOnce = new WeakMap<HTMLVideoElement, boolean>();
  private videoLoadingState = new WeakMap<HTMLVideoElement, boolean>();
  imageLoadingState = new Map<number, boolean>();

  constructor(private promoContentService: PromoContentService,
    private router: Router,
    private libraryV2DataService: LibraryV2DataService, private qrCodeService: QrCodeService,
    private idleService: IdleService
  ) { }

  ngOnInit(): void {
    this.promoContentService.getSelectedPromoIndex.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.selectedPromoIndex = data;
    });
    this.setIntelDisplayOneFont = this.qrCodeService.setenusLang();
    const selectedData = this.promoContentService.promoData[this.selectedPromoIndex];
    this.promoContentData = selectedData?.configurations?.contentGroupPages;    
    this.promoContentData.forEach((_:any, index:any) => {
      this.imageLoadingState.set(index, true);
    });
    this.selectedPromoID = selectedData?.id;
    const userID = this.qrCodeService?.qrInput?.UserId;
    this.assetsUrl = environment.apiBaseUrlAsset + GlobalConstants.PROMO_ASSETS_URL_PART1 + userID + GlobalConstants.PROMO_ASSETS_URL_PART2 + userID + GlobalConstants.PROMO_URL2_PART2 + this.selectedPromoID + GlobalConstants.SLASH;
    this.isPantherLakeStd = this.qrCodeService.isPantherLakeStd;
    this.isPantherLakeGaming = this.qrCodeService.isPantherLakeGaming;
    this.compareButtonText = this.libraryV2DataService.getStaticText('tr_pantherLakeCompareText');
     this.iswildCatLakeStd = this.qrCodeService.isWildCatLakeStd;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.qrCodeService.changeVideoPlayingStatus(false);
  }

  setBgStyle(promoVal: any) {
    return {
      'background-color': promoVal?.bgColor,
      'color': promoVal?.titleFontColor
    }
  }

  onCompareClick() {
    this.router.navigate(['/mob-content'], {
      queryParams: { activeTab: 'compare' },
    });
  }

  //AI Generated:copiot generated code start- For play, pause and loading behaviour of video and image loading checking
  ngAfterViewInit() {
    this.createObserver();
    this.videos.forEach(v => this.observe(v.nativeElement));  // Initial videos
    this.videos.changes.subscribe((list: QueryList<ElementRef<HTMLVideoElement>>) => { // Videos added/removed by *ngIf
      list.forEach(v => this.observe(v.nativeElement));
    });
  }

  private observe(video: HTMLVideoElement): void {
    this.observer.observe(video);
    this.playingState.set(video, false);
    this.userInteracted.set(video, false);
    this.endedOnce.set(video, false);
    this.videoLoadingState.set(video, true);
  }

  toggleVideo(video: HTMLVideoElement): void {
    this.userInteracted.set(video, true); //manual interaction recorded
    if (video.paused) {
      video.play();
      this.playingState.set(video, true);
    } else {
      video.pause();
      this.playingState.set(video, false);
    }
    this.checkAnyVideoPlayingStatus();
  }

  private createObserver(): void {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const video = entry.target as HTMLVideoElement;
          if (this.userInteracted.get(video) || this.endedOnce.get(video)) {  //To prevent autoplay when user interacted or video already ended once
            return;
          }

          //Auto play on 75% of video visibilty
          if (entry.intersectionRatio >= 0.75) {
            video.play();
            this.playingState.set(video, true);
            this.checkAnyVideoPlayingStatus();
          } else {
            video.pause();
            this.playingState.set(video, false);
            this.checkAnyVideoPlayingStatus();
          }
        });
      },
      { threshold: [0.75] }
    );
  }

  onPlayVideo(video: HTMLVideoElement): void {
    this.playingState.set(video, true);
    this.checkAnyVideoPlayingStatus();
  }

  onPauseVideo(video: HTMLVideoElement): void {
    this.playingState.set(video, false);
    this.checkAnyVideoPlayingStatus();
  }

  onVideoEnded(video: HTMLVideoElement): void {
    this.playingState.set(video, false);
    this.videoLoadingState.set(video, false);
    this.endedOnce.set(video, true);
    this.checkAnyVideoPlayingStatus();
  }

  isVideoPlaying(video: HTMLVideoElement): boolean {
    return this.playingState.get(video) === true;
  }

  onVideoLoadStart(video: HTMLVideoElement): void {
    this.videoLoadingState.set(video, true);
  }

  onVideoCanPlay(video: HTMLVideoElement): void {
    this.videoLoadingState.set(video, false);
  }

  onVideoPlaying(video: HTMLVideoElement): void {
    this.videoLoadingState.set(video, false);
    this.playingState.set(video, true);
  }

  onVideoWaiting(video: HTMLVideoElement): void {
    this.videoLoadingState.set(video, true);
  }

  isVideoLoading(video: HTMLVideoElement): boolean {
    return this.videoLoadingState.get(video) === true;
  }

  onImageLoad(index: number): void {
    this.imageLoadingState.set(index, false);
  }

  onImageError(index: number): void {
    this.imageLoadingState.set(index, false);
  }

  isImageLoading(index: number): boolean {
    return this.imageLoadingState.get(index) === true;
  }
  //copiot generated code end

  private checkAnyVideoPlayingStatus(): void {
    const isAnyPlaying = this.videos.toArray().some(v => this.playingState.get(v.nativeElement));
    this.qrCodeService.changeVideoPlayingStatus(isAnyPlaying);
    if (!isAnyPlaying) {
      this.idleService.onUserIdle();
    }
  }
}
